import { render, staticRenderFns } from "./HighlightFooter.vue?vue&type=template&id=e09f74c2&scoped=true&"
import script from "./HighlightFooter.vue?vue&type=script&lang=js&"
export * from "./HighlightFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09f74c2",
  null
  
)

export default component.exports